<mtn-analytics-performance-panel
  [storeData]="analyticsData"
  [uuid]="uuid"
  [banneruuid]="banneruuid"
  [point]="point"
  [isVisible]="true"
  [isFullScreen]="true"
  [isNewPage]="true"
  [cbsa]="cbsa"
  [store]="store"
  [assetReviewStoreDetails]="assetReviewStoreDetails"
  [realEstateQualityData]="realEstateQualityData"
  [bannerStrengthData]="bannerStrengthData"
  [gradeBreakdownData]="gradeBreakdownData"
  [competitiveImpactData]="competitiveImpactData"
  [storePerformanceData]="storePerformanceData"
  [isAnalyticsLoading]="isAnalyticsLoading"
  [isAnalyticsDataLoading]="isAnalyticsDataLoading"
  [analyticsLoadingProgress]="analyticsLoadingProgress"
  [hasAnalyticsError]="hasAnalyticsError"
  [totalAnalyticsApis]="totalAnalyticsApis"
  [class.expanded]="true"
  (downloadPdf)="handleDownloadPdf()"
  (exportData)="handleExportData($event)"
  (expandView)="handleAnalyticsExpand()"
  (openExternal)="handleOpenExternal()"
  (assetReviewClose)="handleAssetReviewClose()"
  (retryAnalytics)="handleRetryAnalytics()"
  [dataValidation] ="dataValidation"
  [loadingdataValidation]="loadingdataValidation"
  class="analytics-performance-panel-full-page"
></mtn-analytics-performance-panel>
